export default "__VITE_ASSET__BeDu6Kbx__"